import { ITchatMessage } from './interface/tchat-message.interface';
import { ITchatUser } from './interface/tchat-user.interface';
import { TchatUser } from './tchat-user';

export class TchatMessage implements ITchatMessage {
    guid: string;
    organizationId: string;

    public source: ITchatUser;

    constructor(
        public roomGuid: string,
        public sourceUser: TchatUser,
        public targetUsers: TchatUser[],
        public date: Date,
        public text: string
    ) {
        this.source = sourceUser;
    }

    public static createFormCopy(chatMessage: ITchatMessage): TchatMessage {
        const instance = new TchatMessage(chatMessage.roomGuid, chatMessage.sourceUser, chatMessage.targetUsers, chatMessage.date, chatMessage.text);
        instance.organizationId = chatMessage.organizationId;
        instance.guid = chatMessage.guid;
        return instance;
    }
}
